import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-tentative-schedule',
  templateUrl: './tentative-schedule.component.html',
  styleUrls: ['./tentative-schedule.component.scss']
})
export class TentativeScheduleComponent implements OnInit {
  TentativeForm: FormGroup;
  SessionFilterList: any;
  sessionList: any;
  sessionId = 0;
  CourseList: any;
  filteredListCourse: any;
  examList: any;
  filteredListExam: any;
  dialogRef: MatDialogRef<any>;
  dialogRef1: MatDialogRef<any>;
  DateArray: FormArray;
  arr: [];
  submitpayload: any;
  errMsg: any;
  TentativeScheduleList: any;
  filteredTentativeSchedule: any;
  APIService: string;
  currentdate: any;
  date: string;
  TsId: any;
  deletedRows: any[] = [];
  examLists: any[] = [];
  // Table = false;
  userPermission
  SessionNo: any;
  print = false;
  tentativeData;
  allTsIds: any[];
  constructor(public fb: FormBuilder,
    public umsService: UmsService,
    private spinner: NgxSpinnerService,
    private modalPopupService: ModalpopService,
    private httpClient: HttpClient,
    public datepipe: DatePipe,
    public router: Router,
    private location: Location,
  ) { this.APIService = environment.serviceUrl; }

  ngOnInit(): void {
    const state = history.state;
    this.tentativeData = state.data;
    if (!this.tentativeData || Object.keys(this.tentativeData).length === 0) {
      this.tentativeData = JSON.parse(localStorage.getItem('tentativeData') || '{}');
    }
    this.fetchTentative();
    this.print = false;
    this.date = this.datepipe.transform(this.currentdate, 'yyyy-MM-dd');
    this.currentdate = new Date();
    let id = ''
    this.sessionId = 0;
    this.arr = [];
    this.TentativeForm = this.fb.group({
      TsmCircularId: new FormControl(''),
      TsId: new FormControl(''),
      SnNo: new FormControl(this.tentativeData.TsmSnNo),
      CircularNumber: new FormControl(this.tentativeData.TsmCircularNumber),
      CircularDate: new FormControl(this.tentativeData.TsmCircularDate),
      ScheduleTime: new FormControl(this.tentativeData.TsmScheduleType),
      ReportCircularNo: new FormControl(this.tentativeData.ReportCircularNo),
      DateArray: new FormArray([]),
    });
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    if (JSON.parse(sessionStorage.getItem("session")) == null) {
      this.fetchSecretData();
    }
    else if (JSON.parse(sessionStorage.getItem("session")) != null) {
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
    }
    this.fetchSession();
    this.getCourse();
    this.selectSessionID();
    this.prepopulatedData();
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
    }
    );
  }
  fetchSession() {
    this.spinner.show();
    const payload = {};
    this.TentativeScheduleList = [];
    this.filteredTentativeSchedule = [];
    this.umsService.getSession(payload).subscribe(res => {
      this.sessionList = [];
      if (res.status) {
        this.spinner.hide()
        res.data.forEach(element => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }
  fetchTentative() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'TST';
    this.TentativeScheduleList = [];
    this.filteredTentativeSchedule = [];
    this.umsService.getCode(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.TentativeScheduleList = res.data;
        this.filteredTentativeSchedule = this.TentativeScheduleList.slice();
      }
      else {
        this.spinner.hide();
        this.TentativeScheduleList = [];
        this.filteredTentativeSchedule = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }
  getCourse() {
    this.spinner.show();
    const payload = {};
    // payload['CgCode'] = id;
    this.umsService.getCourse(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.CourseList = res.data;
        this.filteredListCourse = this.CourseList.slice();
      }
      else {
        this.spinner.hide();
        this.CourseList = [];
        this.filteredListCourse = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.CourseList = [];
    })
  }
  
  getExamList(e: string, index: number, j: number) {
    this.spinner.show();
    const payload = {};
    payload['EmCoCode'] = e;
    this.umsService.getExam(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        // this.examLists[index] = res.data.slice(); // Store exam data for this row
        if (!this.examLists[index]) {
          this.examLists[index] = [];  // Initialize sub-array if not present
        }
        this.examLists[index][j] = res.data.slice(); // Store exam data for this CourseCenter row
      } else {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      // this.umsService.openSnackbar(ERROR.error.message);

    });
  }
  getControls() {
    return (this.TentativeForm.get('DateArray') as FormArray).controls;
  }
  addNewRow() {
    const creds = this.TentativeForm.controls.DateArray as FormArray;
    const newSrNo = creds.length + 1;
    creds.push(
      this.fb.group({
        // CoCode: new FormControl('', [Validators.required]),
        // EmId: new FormControl('', [Validators.required]),
        // tentativeDate: new FormControl('', [Validators.required]),
        TsId: new FormControl(''),
        SrNo: new FormControl(newSrNo),
        CourseCenterArray: new FormArray([]),
      })
    );
    this.addNewCourseCenterRow(0)
  }
  addNewRow2() {
    this.arr = this.TentativeForm.controls.DateArray.value
    this.DateArray = this.TentativeForm.get('DateArray') as FormArray;
    if (this.DateArray.invalid) {
      this.DateArray.controls.forEach(element => {
        // element.get('CoCode').markAsTouched();
        // element.get('EmId').markAsTouched();
        // element.get('tentativeDate').markAsTouched();
        const courseCenters = element.get('CourseCenterArray') as FormArray;
        courseCenters.controls.forEach(center => {
          // center.get('AtUniversityCenters').markAsTouched();
          center.get('CoCode').markAsTouched();
          center.get('EmId').markAsTouched();
          center.get('tentativeDate').markAsTouched();
        });
      })
    }
    else {
      this.arr = this.TentativeForm.controls.DateArray.value
      const creds = this.TentativeForm.controls.DateArray as FormArray;
      const newSrNo = creds.length + 1;
      creds.push(
        this.fb.group({
          // CoCode: new FormControl('', [Validators.required]),
          // EmId: new FormControl('', [Validators.required]),
          // tentativeDate: new FormControl('', [Validators.required]),
          TsId: new FormControl(''),
          SrNo: new FormControl(newSrNo),
          CourseCenterArray: this.fb.array([
            this.fb.group({
              CoCode: new FormControl('', [Validators.required]),
              EmId: new FormControl('', [Validators.required]),
              tentativeDate: new FormControl('', [Validators.required]),
            })
          ]),
        })
      );
    }

  }
  getCourseCenterControls(index: number) {
    const dateArray = this.TentativeForm.controls.DateArray as FormArray;
    const selectedRow = dateArray.at(index); // Get the selected row (index)
    return (selectedRow.get('CourseCenterArray') as FormArray).controls;
  }

  addNewCourseCenterRow(index: number) {
    const dateArray = this.TentativeForm.controls.DateArray as FormArray;
    const selectedRow = dateArray.at(index); // Get the selected row (index)
    const CourseCenterArray = selectedRow.get('CourseCenterArray') as FormArray;
    if (CourseCenterArray.invalid) {
      CourseCenterArray.controls.forEach(element => {
        element.get('CoCode').markAsTouched();
        element.get('EmId').markAsTouched();
        element.get('tentativeDate').markAsTouched();
      })
    }
    else {
      CourseCenterArray.push(
        this.fb.group({
          TsId: new FormControl(''),
          CoCode: new FormControl('', [Validators.required]),
          EmId: new FormControl('', [Validators.required]),
          tentativeDate: new FormControl('', [Validators.required]),
        })
      );
    }
    // Add a new row to the regionalCenterArray for the selected row

  }
  deleteCourseCenterRow(index: number, rowIndex: number): void {
    const dateArray = this.TentativeForm.controls.DateArray as FormArray;
    const selectedRow = dateArray.at(index); // Get the selected row (index)
    const CourseCenterArray = selectedRow.get('CourseCenterArray') as FormArray;

    if (CourseCenterArray.length > 1) {
      const deletedData = CourseCenterArray.at(rowIndex).value;
      this.deletedRows.push(deletedData); // Store deleted data
     CourseCenterArray.removeAt(rowIndex);  // Removes the specified row from regionalCenterArray
    } else {
      let data = {}
      data['message'] = "First Row Can Not Be Deleted"
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

    }

  }
  
  deleteRow(index: number) {
    let formArray = this.TentativeForm.get("DateArray") as FormArray;
    if (formArray.length === 1) {
      // Prevent deleting if only one row remains
      let data = {
        message: "First Row Cannot Be Deleted",
        title: "Information",
        icon: "fas fa-check"
      };
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    } else {
      // Store deleted row data (optional)
      let deletedItem = formArray.at(index).value;
      this.deletedRows.push(deletedItem);

      // Remove row from form array
      formArray.removeAt(index);
      // Fix examLists to maintain correct row mapping
      this.examLists.splice(index, 1);

      formArray.controls.forEach((control, i) => {
        control.get('SrNo').setValue(i + 1);
      });
    }
  }

  submit() {
    this.DateArray = this.TentativeForm.get('DateArray') as FormArray;
    if (this.DateArray.invalid) {
      this.DateArray.controls.forEach(element => {
        const courseCenters = element.get('CourseCenterArray') as FormArray;
        courseCenters.controls.forEach(center => {
          center.get('CoCode').markAsTouched();
          center.get('EmId').markAsTouched();
          center.get('tentativeDate').markAsTouched();
        });
      })
    }
    if (this.TentativeForm.invalid) {
      this.TentativeForm.get('SnNo').markAsTouched();
      this.TentativeForm.get('ScheduleTime').markAsTouched();
      this.TentativeForm.get('CircularNumber').markAsTouched();
      this.TentativeForm.get('CircularDate').markAsTouched();
      return;
    } else {

      this.DeleteTentative();
      // this.AddData();
    }
  }
  DeleteTentative() {
    this.spinner.show();
    this.submitpayload = this.TentativeForm.value;
    let abcd = this.TentativeForm.get('DateArray') as FormArray;
    if (!this.allTsIds || this.allTsIds.length === 0) {
      this.spinner.hide();
      this.AddData(); // No data to delete, so insert directly
      return;
    }
    const allDataToDelete = [
      ...this.allTsIds, // Include all fetched TsdId values
      
    ].map(row => ({
      ...row,
      TsmCircularId: this.tentativeData.TsmCircularId
      }));
   
    // Set up the options with the combined data
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: allDataToDelete, // Send both remaining and deleted rows
    };
    // return
    // Make the delete API call
    this.httpClient.delete(this.APIService + '/inputs/TentativeSchedule', options).subscribe(
      (response) => {
        this.spinner.hide();
        if (response['status'] === true) {
          // this.TentativeForm.get('DateArray').clear(); // Clear the form array after deletion
          this.AddData(); // Reload data if needed
        } else {
          const data = {
            message: response['message'],
            title: 'Information',
            icon: 'fas fa-check'
          };
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        const data = {
          message: ERROR.error.message,
          title: 'Information',
          icon: 'fas fa-close'
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    );
  }

  AddData() {
    this.submitpayload = this.TentativeForm.value;
    // this.getExamList('')
    let abcd = this.TentativeForm.get('DateArray') as FormArray;
    let payload = abcd.value.map(element => ({
      TsmCircularId: this.tentativeData.TsmCircularId,
      SrNo: element.SrNo,
      TsId: element.TsId,
          CourseCenters: element.CourseCenterArray.map(center => {
        return {
            CoCode: center.CoCode,
            EmId: center.EmId,
            tentativeDate: this.datepipe.transform(center['tentativeDate'], 'yyyy-MM-dd'),
        };
      })
    }));

   

    this.umsService.AddTentative(payload).subscribe(res => {
      if (res.status) {
        abcd.clear(); // Clear old values
        this.TentativeForm.reset();
        this.updateTSM();
      }
      else {
        this.spinner.hide();
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      }
    }, (ERROR: HttpErrorResponse) => {
      this.errMsg = ERROR.error.message;
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  
  prepopulatedData() {
    this.DateArray = this.TentativeForm.get('DateArray') as FormArray;
    this.DateArray.clear(); // Clear existing form array
    this.examLists = []; // Clear examLists array
    this.allTsIds = []; // Store all TsId values

    let payload = {
      SnNo: this.TentativeForm.value.SnNo,
      Schedule: this.TentativeForm.value.ScheduleTime,
      TsmCircularId: this.tentativeData.TsmCircularId,
      IsReportRequest: ''
    };
  
    this.umsService.getTentative(payload).subscribe(res => {
      if (res.status && Array.isArray(res.data) && res.data.length) {
        this.DateArray.clear(); // Ensure form array is empty before adding new data
    this.examLists = []; // Reset exam lists 

        // **Group data by SrNo**
        let groupedData = res.data.reduce((acc, item) => {
          acc[item.SrNo] = acc[item.SrNo] || [];
          acc[item.SrNo].push(item);
          return acc;
        }, {});
  
        // Loop through each group and add rows accordingly
        Object.keys(groupedData).forEach((srNo, index) => {
          const firstElement = groupedData[srNo][0]; // Get first item in the group
  
          groupedData[srNo].forEach(item => {
            if (item.TsId && !this.allTsIds.some(ts => ts.TsId === item.TsId)) {
              this.allTsIds.push({ TsId: item.TsId }); // Add only unique TsId
            }
          });

          const rowGroup = this.fb.group({
            SrNo: new FormControl(srNo),
            CoCode: new FormControl(firstElement.CoCode, [Validators.required]),
            EmId: new FormControl(firstElement.EmId, [Validators.required]),
            tentativeDate: new FormControl(this.datepipe.transform(firstElement.TentativeDate, 'yyyy-MM-dd'), [Validators.required]),
            TsId: new FormControl(firstElement.TsId),
            CourseCenterArray: this.fb.array([]) // Create an array for Course Centers
          });
  
          // Get the CourseCenterArray within this row
          let courseCenterArray = rowGroup.get('CourseCenterArray') as FormArray;
     this.examLists[index] = []; // Initialize exam list for this row

          // Add each course center under the same SrNo
          groupedData[srNo].forEach((center,j) => {
            courseCenterArray.push(this.fb.group({
              CoCode: new FormControl(center.CoCode),
              EmId: new FormControl(center.EmId),
              tentativeDate: new FormControl(this.datepipe.transform(center.TentativeDate, 'yyyy-MM-dd')),
              // TsId: new FormControl(center.TsId || '') // Ensure TsId is handled properly
            }));

          // Fetch exam list for each course center
          this.getExamList(center.CoCode, index, j);

          });
  
          // Push this group to DateArray
          this.DateArray.push(rowGroup);
        });
  
      } else {
        this.allTsIds = [];
        this.DateArray.clear();
        this.addNewRow(); // Add an empty row if no data is available
      }
    });
  }
  
  selectSessionID() {
    this.prepopulatedData()
  }

  Print() {
    let submitpayload = this.TentativeForm.value;
    let payload1 = {}
    payload1['SnNo'] = this.TentativeForm.value.SnNo,
      payload1['Schedule'] = this.TentativeForm.value.ScheduleTime;
    payload1['TsmCircularId'] = this.tentativeData.TsmCircularId;
    let jsonString = JSON.stringify(payload1)
    var filter: any;
    filter = {
      "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
      "RptCode": 302,
      "InstName": '',
      "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
      "ShId": '',
      "CgCode": '',
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId": '',
      "CsNo": '',
      "PgBreak": '',
      "StrId": '',
      "StrCode": '',
      "RgNo": '',
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": '',
      "SnNo": this.TentativeForm.value.SnNo,
      "Extra1": jsonString,
    }

    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.redirect('reports')
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  
  validateDuplicateExam(dateIndex: number, centerIndex: number) {
    this.DateArray = this.TentativeForm.get('DateArray') as FormArray;
    const courseCenterArray = this.DateArray.at(dateIndex).get('CourseCenterArray') as FormArray;
  
    const selectedExam = courseCenterArray.at(centerIndex).get('EmId').value;
    const selectedCourse = courseCenterArray.at(centerIndex).get('CoCode').value;
  
    if (!selectedExam || !selectedCourse) return;
  
    let isDuplicate = false;
  
    this.DateArray.controls.forEach((dateControl, i) => {
      const otherCourseCenters = dateControl.get('CourseCenterArray') as FormArray;
      otherCourseCenters.controls.forEach((otherCourseControl, j) => {
        if (
          !(i === dateIndex && j === centerIndex) &&  // Exclude current selection
          otherCourseControl.get('EmId').value === selectedExam &&
          otherCourseControl.get('CoCode').value === selectedCourse
        ) {
          isDuplicate = true;
        }
      });
    });
  
    if (isDuplicate) {
      let data = {
        message: 'This Exam Is Already Scheduled',
        title: 'Alert',
        icon: 'fas fa-close'
      };
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  
      // Reset the exam selection
      courseCenterArray.at(centerIndex).get('EmId').setValue('');
    }
  }
  
  
  checkforData() {
    this.DateArray = this.TentativeForm.get('DateArray') as FormArray;
    if (this.DateArray.value.length > 0) {
      return true;
    } else {
      return false;
    }
  }
  convertUTCToIST(dateString: string): string {
    const utcDate = new Date(dateString);
    // Convert UTC to IST manually
    const istOffset = 5.5 * 60 * 60 * 1000; // IST is UTC +5:30
    const istDate = new Date(utcDate.getTime() + istOffset);

    // Format the IST date in the required format
    const year = istDate.getFullYear();
    const month = String(istDate.getMonth() + 1).padStart(2, '0'); // Month is 0-based
    const day = String(istDate.getDate()).padStart(2, '0');
    const hours = String(istDate.getHours()).padStart(2, '0');
    const minutes = String(istDate.getMinutes()).padStart(2, '0');
    const seconds = String(istDate.getSeconds()).padStart(2, '0');
    const milliseconds = String(istDate.getMilliseconds()).padStart(3, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`;
  }
  updateTSM() {
    let submitpayload = this.TentativeForm.value;
    let circularDateUTC = this.submitpayload.CircularDate
      ? this.convertUTCToIST(this.submitpayload.CircularDate)
      : null;
    const payload = {};
    payload['TsmCircularId'] = this.tentativeData.TsmCircularId,
      payload['TsmCircularNumber'] = this.submitpayload.CircularNumber,
      payload['TsmCircularDate'] = circularDateUTC,
      payload['TsmSnNo'] = this.submitpayload.SnNo,
      payload['TsmScheduleType'] = this.submitpayload.ScheduleTime,
      payload['ReportCircularNo'] = this.submitpayload.ReportCircularNo
    
    this.umsService.UpdateTentativeMaster(payload).subscribe(
      (res) => {
        if (res.status) {
          this.spinner.hide();
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          //  Store updated data in localStorage
          localStorage.setItem('tentativeData', JSON.stringify(payload));
          // this.ngOnInit();
          //  Update tentativeData with the latest data
          this.tentativeData = { ...this.tentativeData, ...payload };
          //  Directly update the form with new values
          this.TentativeForm.patchValue({
            SnNo: this.tentativeData.TsmSnNo,
            CircularNumber: this.tentativeData.TsmCircularNumber,
            CircularDate: this.tentativeData.TsmCircularDate,
            ScheduleTime: this.tentativeData.TsmScheduleType,
            ReportCircularNo: this.tentativeData.ReportCircularNo
          });
          this.prepopulatedData();
        } else {
          this.spinner.hide();
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-close';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          // this.dialogRef.afterClosed().subscribe(result => {
          this.ngOnInit();
          // });
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    );
  }



  Back() {
    this.goBack();
  }
  goBack(): void {
    this.location.back();
  }

  prepopulation(data) {
    this.TentativeForm = this.fb.group({
      SnNo: new FormControl(data.TsmSnNo),
      CircularNumber: new FormControl(data.TsmCircularNumber),
      CircularDate: new FormControl(data.TsmCircularDate),
      ScheduleTime: new FormControl(data.TsmScheduleType),
      ReportCircularNo: new FormControl(data.ReportCircularNo)
    });
  }

  
  datechange(i: number, j: number) {
    let taskListArrays = this.TentativeForm.get('DateArray') as FormArray;
    let courseCenterArray = taskListArrays.at(i).get('CourseCenterArray') as FormArray;
    let tentativeDateControl = courseCenterArray.at(j).get('tentativeDate'); // ✅ Correct way to access
  
    let circularDateControl = this.TentativeForm.get('CircularDate'); // Get circular date
  
    let tentativeDate = tentativeDateControl.value ? new Date(tentativeDateControl.value) : null;
    let circularDate = circularDateControl?.value ? new Date(circularDateControl.value) : null;
  
    //  Validate that tentative date is greater than circular date
    if (tentativeDate && circularDate) {
      if (tentativeDate <= circularDate) {
        let formattedCircularDate = circularDate.toLocaleDateString('en-GB'); // Format as "DD/MM/YYYY"
        let data = {
          message: `Tentative Date must be greater than POE Date (${formattedCircularDate})`,
          title: 'Information',
          icon: 'fas fa-close'
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        tentativeDateControl.setValue(''); // Clear invalid date
        tentativeDateControl.setErrors({ dateError: true }); // Set validation error
        return; // Stop further validation
      }
    }
  
    //  Validate that each tentative date is greater than the previous row’s date
    if (i > 0) {
      let prevTaskList = taskListArrays.at(i - 1) as FormGroup;
      let prevCourseCenterArray = prevTaskList.get('CourseCenterArray') as FormArray;
    
      // Ensure previous index exists
      if (prevCourseCenterArray && prevCourseCenterArray.length > j) {
        let previousTentativeDateControl = prevCourseCenterArray.at(j).get('tentativeDate');
    
        if (previousTentativeDateControl) {
          let previousTentativeDate = previousTentativeDateControl.value ? new Date(previousTentativeDateControl.value) : null;
    
          if (previousTentativeDate && tentativeDate && tentativeDate < previousTentativeDate) {
            let formattedPrevDate = previousTentativeDate.toLocaleDateString('en-GB'); // Format as "DD/MM/YYYY"
            let data = {
              message: `Tentative Date Must Be Greater Than The Previous Row’s Date`,
              title: 'Information',
              icon: 'fas fa-close'
            };
            this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
            tentativeDateControl.setValue(''); // Clear invalid date
            // tentativeDateControl.setErrors({ dateSequenceError: true }); // Set validation error
            return; // Stop further validation
          }
        }
      }
    }
    if (j > 0) {
      let previousTentativeDateControl = courseCenterArray.at(j - 1).get('tentativeDate');
  
      if (previousTentativeDateControl) {
        let previousTentativeDate = previousTentativeDateControl.value ? new Date(previousTentativeDateControl.value) : null;
  
        if (previousTentativeDate && tentativeDate && tentativeDate < previousTentativeDate) {
          let formattedPrevDate = previousTentativeDate.toLocaleDateString('en-GB'); // Format as "DD/MM/YYYY"
          let data = {
            message: `Tentative Date Must Be Greater Than The Previous Row’s Date`,
            title: 'Information',
            icon: 'fas fa-close'
          };
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          tentativeDateControl.setValue(''); // Clear invalid date
          tentativeDateControl.setErrors({ dateSequenceError: true }); // Set validation error
          return; // Stop further validation
        }
      }
    }
  
    //  If all validations pass, clear any errors
    tentativeDateControl.setErrors(null);
  }

  
}
